// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCTml0PU3QjRGLdNL2MhdtTpp7HOso9U-k",
  authDomain: "web-app-a29e2.firebaseapp.com",
  projectId: "web-app-a29e2",
  storageBucket: "web-app-a29e2.firebasestorage.app",
  messagingSenderId: "913898309921",
  appId: "1:913898309921:web:be2f261e9b1ba501395660",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
export const db = getFirestore(app);